// src/extenders/surf-expand.js
var SurfExpand = class extends HTMLElement {
  constructor() {
    super();
    const surfExpandElement = this;
    const ariaControls = surfExpandElement.getAttribute("aria-controls");
    const summaryElement = surfExpandElement.querySelector(".surf-expand__summary");
    const contentElement = surfExpandElement.querySelector(`[aria-label="${ariaControls}"]`);
    const iconChevronElement = surfExpandElement.querySelector(".icon-chevron");
    const iconPlusElement = surfExpandElement.querySelector(".icon-plus");
    const currentState = surfExpandElement.getAttribute("aria-expanded");
    const handleExpandElement = (surfExpandElement2, contentElement2) => {
      const currentState2 = surfExpandElement2.getAttribute("aria-expanded");
      if (currentState2 === "true") {
        surfExpandElement2.setAttribute("aria-expanded", "false");
        iconChevronElement.classList.add("js-closed");
        iconChevronElement.classList.remove("js-open");
        contentElement2.hidden = true;
      } else {
        surfExpandElement2.setAttribute("aria-expanded", "true");
        iconChevronElement.classList.remove("js-closed");
        iconChevronElement.classList.add("js-open");
        contentElement2.hidden = false;
      }
    };
    summaryElement == null ? void 0 : summaryElement.addEventListener("click", () => {
      handleExpandElement(surfExpandElement, contentElement);
    }, true, { passive: true });
    if (currentState === "false") {
      contentElement.hidden = true;
      iconChevronElement.classList.add("js-closed");
      iconChevronElement.classList.remove("js-open");
    }
    if (currentState === "true") {
      iconChevronElement.classList.remove("js-closed");
      iconChevronElement.classList.add("js-open");
      contentElement.hidden = false;
    }
  }
};
if (customElements.get("surf-expand") === void 0) {
  customElements.define("surf-expand", SurfExpand);
}
